import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getSortedBlogPosts } from '../../content/blogPosts';
import useLangPrefix from '../../hooks/useLangPrefix';
import './Blog.css';

function BlogIndex() {
  const { t, i18n } = useTranslation();
  const langPrefix = useLangPrefix();
  const posts = getSortedBlogPosts();
  const faq = t('blog.faq', { returnObjects: true });

  return (
    <>
      <section className="py-5 py-lg-6 bg-white">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-lg-8 text-center">
              <h1 className="h3 fw-semibold text-navy mb-2">{t('blog.heading')}</h1>
              <p className="text-muted mb-0">{t('blog.subheading')}</p>
            </div>
          </div>
          <div className="row g-4">
            {posts.map((post) => {
              const content = post[i18n.language] || post.ar;
              const dir = post[i18n.language] ? undefined : 'rtl';
              const formattedDate = new Date(post.date).toLocaleDateString(
                i18n.language === 'ar' ? 'ar-LB' : 'en-US',
                { year: 'numeric', month: 'long', day: 'numeric' }
              );
              return (
                <div className="col-md-6 col-lg-4" key={post.slug}>
                  <Link to={`${langPrefix}/blog/${post.slug}`} className="text-decoration-none">
                    <div className="card h-100 border-0 shadow-sm" dir={dir}>
                      <div className="card-body p-4">
                        <p className="text-muted small mb-2">{formattedDate}</p>
                        <h2 className="h6 fw-semibold text-navy mb-3">{content.title}</h2>
                        <p className="card-text small text-muted mb-0">{content.metaDescription}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {Array.isArray(faq) && faq.length > 0 && (
        <section className="py-5 py-lg-6 bg-light border-top">
          <div className="container">
            <div className="row justify-content-center mb-4 mb-lg-5">
              <div className="col-lg-8 text-center">
                <h2 className="h3 fw-semibold text-navy mb-0">{t('blog.faqHeading')}</h2>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="accordion" id="blogFaq">
                  {faq.map((item, i) => (
                    <div className="accordion-item" key={i}>
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#faqItem${i}`}
                        >
                          {item.q}
                        </button>
                      </h3>
                      <div id={`faqItem${i}`} className="accordion-collapse collapse" data-bs-parent="#blogFaq">
                        <div className="accordion-body">{item.a}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default BlogIndex;
